import _ from 'lodash';
import { useRef } from 'react';

import Cta from './Cta';
import RichText, { isDeltaEmpty } from './RichText';
import Text from './utilities/Text';
import Card from '../oc-card-new';
import ChevronLink from '../oc-chevron-link';
import { H3 } from '../oc-h';
import Paragraph from '../oc-p';
import Picture from '../oc-picture';
import WrapperLink from '../oc-wrapper-link';

const CMSCard = ({
  img,
  alt,
  icon,
  children,
  prehead,
  heading,
  text,
  linkText,
  url,
  closing,
  socialShare,
  overrideImageURLSwitch,
  overrideImageURL,
  ctaSwitch,
  ctaProps,
  crop,
  ...props
}) => {
  const CtaButtonRef = useRef(null);
  const handleCtaButtonClick = e => {
    if (CtaButtonRef.current) {
      e.preventDefault();
      CtaButtonRef.current?.click();
    }
  };

  return (
    <Card
      img={crop ? Picture.Transform(img, { crop: 'crop', ...crop }) : img}
      alt={alt}
      icon={icon}
      url={overrideImageURLSwitch ? overrideImageURL : ctaSwitch ? CtaButtonRef?.current?.href || '#' : url}
      linkText={linkText}
      socialShare={socialShare}
      ctaSwitch={ctaSwitch}
      handleCtaButtonClick={handleCtaButtonClick}
      {...props}
    >
      <WrapperLink
        url={overrideImageURLSwitch ? overrideImageURL : ctaSwitch ? CtaButtonRef?.current?.href || '#' : url}
        tabIndex="-1"
        aria-label={alt || heading || prehead || 'Learn More'}
        /* eslint-enable react/prop-types */
        {...(!!ctaSwitch && { onClick: handleCtaButtonClick })}
      >
        {/* In case text after heading is empty,
        we want to use paragraph tag instead of heading tag for better accessibility */}
        {heading && isDeltaEmpty(text) ? (
          <Paragraph prehead={prehead} font="body">
            <Text content={heading} />
          </Paragraph>
        ) : null}

        {heading && !isDeltaEmpty(text) ? (
          <H3 prehead={prehead} tag="h3" font="body">
            <Text content={heading} />
          </H3>
        ) : null}
      </WrapperLink>

      <RichText content={text} />

      {/* Only add Chevron Link if url or linkText is present */}
      {!ctaSwitch && linkText && (
        <ChevronLink url={url} ariaLabel={linkText}>
          <Text content={linkText} />
        </ChevronLink>
      )}

      {!ctaSwitch && closing ? (
        <p>
          <Text content={closing} />
        </p>
      ) : null}
      {!!ctaSwitch &&
        (_.isArray(ctaProps) ? (
          // eslint-disable-next-line react/prop-types
          ctaProps?.map(ctaPropItem => (
            <div key={ctaPropItem.url}>
              {/* eslint-disable-next-line react/jsx-props-no-spreading */}
              <Cta {...ctaPropItem} forwardRef={CtaButtonRef} />
            </div>
          ))
        ) : (
          <div>
            {/* eslint-disable-next-line react/jsx-props-no-spreading */}
            <Cta {...ctaProps} forwardRef={CtaButtonRef} />
          </div>
        ))}
    </Card>
  );
};

export default CMSCard;
